import { typography } from '@scp/ui-shared/theme/variables';
export var ALT_BUTTON_SIZE = {
  fontSize: typography.defaultFontSize,
  size: 30
};
export var E2E = {
  MAIN: '-button',
  ACTION: '-action-button'
};
export var ALT_BUTTON_APPEARANCE = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  DANGER: 'danger'
};